import PollSlider from './PollSlider';
import PollSliderContainer from './PollSlider.container';

export default PollSliderContainer(PollSlider);
